import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  Icon,
  Space,
  useModal,
} from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { queueTrackingEvent } from '@library/tracking-integration'

import { menuSearchModalOpen } from 'actions/trackingKeys'
import { getBasketMenuUuid } from 'selectors/basket'

import { recipeSearchModalName } from '../RecipeSearchModal/RecipeSearchModal'

type TrackSearchButtonClick = {
  action: typeof menuSearchModalOpen
  properties: {
    menu_id: string
  }
}
const onSpaceOrEnter =
  (callback: (event: React.KeyboardEvent) => void) => (event: React.KeyboardEvent) => {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.preventDefault()
      callback(event)
    }
  }

type SearchButtonProps = {
  menuId?: string
}

export const SearchButton = ({ menuId }: SearchButtonProps = {}) => {
  const basketMenuUuid = useSelector(getBasketMenuUuid)
  const menuUuid = menuId ?? basketMenuUuid
  const { openModal } = useModal()
  const isDisabled = !basketMenuUuid

  const onClick = () => {
    openModal(recipeSearchModalName)

    datadogRum.addAction('open_search', { menu_id: menuUuid })
    queueTrackingEvent<TrackSearchButtonClick>({
      action: menuSearchModalOpen,
      properties: {
        menu_id: menuUuid,
      },
    })
  }

  return (
    <>
      <Box
        alignItems={AlignItems.Center}
        aria-label="Open menu search"
        aria-disabled={isDisabled}
        bg={Color.NeutralGrey_50}
        borderRadius={1.5}
        data-testid="search-button"
        display={Display.Flex}
        height="40px"
        onClick={isDisabled ? undefined : onClick}
        onKeyDown={isDisabled ? undefined : onSpaceOrEnter(() => onClick())}
        paddingH={[2, 4]}
        role="button"
        tabIndex={isDisabled ? -1 : 0}
      >
        <Icon name="search" size={6} />
        <Space size={[1, 2]} direction="horizontal" />
        <Body2>Search the menu</Body2>
      </Box>
    </>
  )
}
